import {
  ACCOMMODATION_FORMS_NUMBERS,
  ACCOMMODATION_FORMS_ORDER,
  ACCOMMODATION_PRICES_FORMS_NUMBERS
} from 'pages/create-accommodation/constants';

export const isDiscardSection = (
  activeTab,
  newActiveTab,
  pricesActiveSubTab,
  savedForms
) => {
  if (activeTab === newActiveTab) return false;

  if (
    activeTab === ACCOMMODATION_FORMS_NUMBERS.pricesForm &&
    savedForms.pricesTab &&
    savedForms.pricesTab !==
      ACCOMMODATION_FORMS_ORDER[activeTab][pricesActiveSubTab]
  ) {
    return true;
  }
};

export const discardSection = (
  activeTab,
  newActiveTab,
  setPricesActiveSubTab,
  setActiveTab,
  initializeForm,
  savedForms,
  initialFormData
) => {
  if (activeTab === ACCOMMODATION_FORMS_NUMBERS.pricesForm) {
    const formName = savedForms.pricesTab;
    setPricesActiveSubTab(ACCOMMODATION_PRICES_FORMS_NUMBERS[formName]);

    initializeForm(
      formName,
      savedForms[formName] || initialFormData[formName] || {}
    );
  }

  setActiveTab(newActiveTab);
};
